import React from 'react';
import Image from 'next/image';
import Container from '../../../layout/Container';
import ExternalLink from '@/components/elements/ExternalLink';

export default function ImageBackground({
  block,
  position,
  entry_uid,
  backgroundColor
}) {
  const {
    title,
    description,
    background_image,
    link_text,
    link,
    background_overlay_on,
    background_overlay_color,
    text_color,
    external_link,
    link_type
  } = block.image_background;
  const bgClass = `bg-[${background_overlay_color}]`;
  const backgroundClass = `bg-[${backgroundColor}]`;

  return (
    <section
      id={`${entry_uid}_${position}`}
      data-name="wayfinder-image-background"
      className={`wayfinder-image-background relative h-full bg-cover bg-center bg-no-repeat py-20 sm:py-[120px] text-[${text_color}] relative ${background_overlay_on ? `${bgClass}` : `${backgroundClass}`}`}
    >
      {background_image && (
        <div
          className={`absolute top-0 left-0 h-full w-full ${background_overlay_on ? `z-10 opacity-70` : ''}`}
        >
          <Image
            src={background_image.url}
            alt={background_image.title.replace(/\.[^/.]+$/, '')}
            fill
            sizes="100vw"
            className="absolute top-0 left-0 z-0 object-cover"
          />
        </div>
      )}
      <div className="relative z-30">
        <Container>
          <h2 className="h3 lg:h2 mb-10 text-center">{title}</h2>
          <p className="body-r mx-auto mb-10 max-w-[960px] px-5 text-center sm:px-15 lg:px-[120px]">
            {description}
          </p>
          {(link.trim() || external_link?.href) && (
            <div className="text-center">
              <ExternalLink
                linkType={link_type}
                linkStyling={`${text_color == '#ffffff' ? 'txt-btn-secondary-white' : 'txt-btn-secondary'} body-r pb-1 inline-block`}
                externalLink={external_link}
                internalLink={link}
                linkText={link_text}
              />
            </div>
          )}
        </Container>
      </div>
    </section>
  );
}
